import { network } from '.';
import { strings } from '.';
import api from '../config/api';
import { stringify } from 'qs';
// {
//     dataUrl: '',//数据请求地址 作为匹配数据的主键
//     url: '',//跳转页面的地址 AddLog的时候设置为window.location.href
//     eventType: '',//埋点事件类型：左侧菜单、搜索记录、顶部菜单(订单中心、行业专区等)、购物车、首页轮播
//     scene: '',//场景 为搜索、左侧菜单时使用，用来区分点击场景：首页、产品页
//     ... : '',//请求参数 AddLog的时候设置
// }
// isSearch  判断当前查询页面是否有搜索条件   无  false 有 true
export const logDataArr = [
  //顶部菜单
  {
    dataUrl: '/cust/orderDetails.do',
    eventType: '订单明细',
    scene: '订单中心',
    isSearch: false,
  },
  {
    dataUrl: 'cust/queryRoMasList.do',
    eventType: '退货记录',
    scene: '订单中心',
    isSearch: false,
  },
  {
    dataUrl: '/cust/deliveryOrderSum.do',
    eventType: '出货单记录',
    scene: '订单中心',
    isSearch: false,
  },
  {
    dataUrl: '/cust/deliveryOrderPrint.do',
    eventType: '出货单列印',
    scene: '订单中心',
    isSearch: false,
  },
  {
    dataUrl: '/cust/consolidatedPayment.do',
    eventType: '出货单对账',
    scene: '订单中心',
    isSearch: false,
  },
  {
    dataUrl: '/cust/queryCustSoUnpaidSums.do',
    eventType: '应收账款对账',
    scene: '订单中心',
    isSearch: false,
  },
  // {
  //   dataUrl: '/cust/es/queryItemSpecial.do',
  //   eventType: '特价区',
  //   scene: '活动专区',
  // },
  {
    dataUrl: '/api/biz/sp/pcJackPot.do',
    eventType: '幸运大抽奖',
    scene: '活动专区',
    isIncludes: true,
  },
  // {
  //   dataUrl: 'api/b2b/sp/queryInstantRebateItem.do',
  //   eventType: '满减区',
  //   scene: '活动专区',
  //   isSearch: false,
  // },
  // {
  //   dataUrl: '/api/biz/sp/selectFlashSalesRounds.do',
  //   eventType: '东明20日',
  //   scene: '活动专区',
  // },
  // {
  //   dataUrl: 'api/b2b/sp/queryMultiItem.do',
  //   eventType: '多满减',
  //   scene: '活动专区',
  // },
  // {
  //   dataUrl: '/api/biz/sp/queryindustries.do',
  //   eventType: '行业专区',
  //   scene: '行业专区',
  // },
  // {
  //   dataUrl: '/cust/judgeApplyFiance.do',
  //   eventType: '东明金融-周转通',
  // },
  {
    dataUrl: '/cust/loanDetail.do',
    eventType: '我的周转通',
    scene: '东明金融',
  },
  // {
  //   dataUrl: '/api/sys/sm/confs.do',
  //   eventType: '随宁贴',
  //   scene: '东明金融',
  // },
  // {
  //   dataUrl: '/cust/queryUserItemNew.do',
  //   eventType: '自定义编码',
  //   scene: '快速下单',
  // },
  // {
  //   dataUrl: '/cust/queryCollectionNew.do',
  //   eventType: '收藏夹',
  //   scene: '快速下单',
  //   isSearch: false,
  // },
  {
    dataUrl: '/cust/queryDataDownload01.do',
    eventType: '公共资料宣传',
    scene: '资料下载',
  },
  // {
  //   dataUrl: '/cust/queryCreatifiContent',
  //   eventType: '资料下载-产品品质证明',
  //   isIncludes: true,
  // },
  {
    dataUrl: '/cust/queryDataDownload03.do',
    eventType: '产品技术资料',
    scene: '资料下载',
  },
  {
    dataUrl: '/cust/queryDataDownload04.do',
    eventType: '公司资质证书',
    scene: '资料下载',
  },
  {
    dataUrl: '/cust/queryDataDownload05.do',
    eventType: '电子牌价',
    scene: '资料下载',
  },
  {
    dataUrl: '/cust/activityCoupons.do',
    eventType: '优惠券',
    scene: '活动专区[旧]',
  },
  {
    dataUrl: '/api/biz/sp/querySalesSetInValid.do',
    eventType: '组合销售',
    scene: '活动专区[旧]',
  },
  // {
  //   dataUrl: '/cust/pageExclusiveCustSer.do',
  //   eventType: '售后服务-意见反馈',
  // },
  {
    dataUrl: '/cust/queryFeeBacks.do',
    eventType: '投诉处理记录',
    scene: '售后服务',
    isSearch: false,
  },
  {
    dataUrl: '/cust/queryNoticeHelp.do',
    eventType: '常见问题',
    scene: '售后服务',
  },
  //购物车
  {
    dataUrl: '/cust/mcuByLoginNameAll.do',
    eventType: '购物车',
    scene: '购物车',
  },
  //搜索/左侧菜单 搜索和左侧菜单都是这个接口 在动作触发的时候动态设置eventType和scene
  {
    dataUrl: '/cust/es/search.do',
    eventType: '', //关键词搜索 热词搜索 左侧菜单 选项搜索  分页搜索
    scene: '', //关键词搜索 热词搜索 左侧菜单；当eventType为选项搜索时 需要标记是由哪个场景进入搜索页的
    isClearEventType: true,
    isClerScene: true,
    isHomeSearch: true,
  },
  {
    dataUrl: '/cust/saveFavoriteSpec.do',
    eventType: '收藏',
    scene: '收藏',
  },
  {
    dataUrl: '/cust/saveSpecCode.do',
    eventType: '自定义',
    scene: '自定义',
  },
  {
    dataUrl: '/cust/expUitemCode.do',
    eventType: '自定义编码',
    scene: '快速下单',
    eventType1: '下载自定义编码',
  },
  {
    dataUrl: '/api/sys/file/template.do',
    eventType: '自定义编码',
    scene: '快速下单',
    eventType1: '下载模板',
  },
  {
    dataUrl: '/cust/uploadCustomCode.do',
    eventType: '自定义编码',
    scene: '快速下单',
    eventType1: '上传文件',
  },
  //轮播图不请求url 所以在动作触发的时候直接上报Log
];

export function getLogData(dataUrl) {
  return logDataArr.find((item) =>
    item.isIncludes ? dataUrl.includes(item.dataUrl) : dataUrl === item.dataUrl,
  );
}

export function setLogData(dataUrl, payload) {
  const logData = getLogData(dataUrl);
  if (logData) {
    Object.assign(logData, payload);
  }
}

export function AddLog(params) {
  try {
    const dataUrl = params.url;
    const reqParams = params.params || {};
    const reqData = params.data || {};
    const requestParams = { ...reqParams, ...reqData };
    const logData = getLogData(dataUrl);
    if (logData) {
      if (logData.dataUrl !== '/cust/es/search.do') {
        if (logData.isSearch) {
          logData['eventType1'] = '选项搜索';
        } else {
          // 删除对象中的某一属性
          Reflect.deleteProperty(logData, 'eventType1');
        }
      }
      let params = {};
      if (logData.dataUrl === '/cust/es/search.do') {
        if (
          Object.keys(logData).includes('isKeyWords') &&
          Object.keys(requestParams).includes('CAT_30') &&
          requestParams['CAT_30'].length > 0
        ) {
          let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
          let standard = requestParams['CAT_30'].join(',');
          params = {
            ...logData,
            url: window.location.href,
            ...requestParams,
            ibsrp7: requestParams['CAT_30'].slice(-1)[0].split(',')[0],
            eventType: logData.isStandard
              ? reg.test(standard)
                ? '无效搜索'
                : '标准'
              : logData.eventType,
          };
        } else {
          params = {
            ...logData,
            url: window.location.href,
            ...requestParams,
            ibsrp7:
              Object.keys(requestParams).includes('ibsrp7') &&
              Array.isArray(requestParams['ibsrp7']) &&
              requestParams['ibsrp7'].length > 0
                ? requestParams['ibsrp7'].slice(-1)[0]
                : requestParams.ibsrp7,
          };
        }
      } else {
        params = { ...logData, url: window.location.href, ...requestParams };
      }
      logData.isClearEventType && (logData.eventType = '');
      logData.isClerScene && (logData.scene = '');

      if (params.dataUrl && params.eventType) {
        network({
          url: api.biLog.addLog,
          method: 'get',
          params: { ...params, silence: true },
          paramsSerializer: (params) => {
            return stringify(params, {
              arrayFormat: params.dataUrl === '/cust/es/search.do' ? 'repeat' : 'brackets',
            });
          },
        });
      }
      // network.get(api.biLog.addLog, { params, silence: true });
    }
  } catch (error) {}
}
export const searchEventType = {
  keyWords: '关键词搜索',
  hotWords: '热词搜索',
  letfMenu: '左侧菜单',
  options: '选项搜索',
  page: '分页搜索',
};

export function setSerachLog(eventType, type) {
  const logData = getLogData('/cust/es/search.do');
  if (logData) {
    eventType && (logData.eventType = eventType);
    const queryParams = strings.fromQs();
    const { quickLink, search } = queryParams;
    if (
      eventType == searchEventType.options ||
      eventType == searchEventType.page ||
      eventType == searchEventType.addCart
    ) {
      if (search) {
        //关键词搜索标志
        logData.scene = searchEventType.keyWords;
        logData.eventType = type ? type : searchEventType.keyWords;
        logData.eventType1 = eventType;
        logData.isKeyWords = true;
        logData.isStandard = type === '标准' ? true : false;
      } else if (quickLink) {
        //热词搜索标志
        logData.scene = searchEventType.hotWords;
        logData.eventType = type ? type : searchEventType.hotWords;
        logData.eventType1 = eventType;
      } else {
        logData.scene = searchEventType.letfMenu;
        logData.eventType = type ? type : searchEventType.letfMenu;
        logData.eventType1 = eventType;
      }
    } else {
      logData.scene = eventType;
      logData.eventType = type ? type : eventType;
      logData.eventType1 = '';
    }
  }
}

export function setOrderDetailLog(type, eventType) {
  let url = '';
  if (type === 'detail') {
    url = '/cust/orderDetails.do';
  } else if (type === 'returnRecord') {
    url = 'cust/queryRoMasList.do';
  } else if (type === 'saleTotal') {
    url = '/cust/deliveryOrderSum.do';
  } else if (type === 'saleLine') {
    url = '/cust/deliveryOrderPrint.do';
  } else if (type === 'payTogether') {
    url = '/cust/consolidatedPayment.do';
  } else if (type === 'accountDue') {
    url = '/cust/queryCustSoUnpaidSums.do';
  }
  const logData = getLogData(url);
  if (logData) {
    logData.isSearch = eventType;
  }
}

export function setFeedbackRecordLog(eventType1) {
  let url = '/cust/queryFeeBacks.do';
  const logData = getLogData(url);
  if (logData) {
    logData.isSearch = eventType1;
  }
}
